<template>
    <az-formbar>
        <div class="hide">
            <div class="itens"></div>
            <div class="actions"></div>
        </div>
    </az-formbar>
</template>

<script>
    export default {
        name: 'ComissaoAcoes'
    }
</script>